import React, { ComponentProps } from 'react';
import { BaseButton, Icon } from '@common/components';

type BaseProps = ComponentProps<typeof BaseButton>;

export const UploadButton = ({
  children,
  type = 'default',
  ...props
}: Omit<BaseProps, 'icon'>) => {
  const iconSize =
    {
      large: 'md',
      middle: 'md',
      small: 'sm',
    }[props.size as string] || 'md';

  return (
    <BaseButton
      {...props}
      type={type}
      icon={
        <Icon
          icon="arrowUpFromBracket"
          kind="regular"
          size={iconSize as 'md' | 'sm'}
        />
      }
    >
      {children}
    </BaseButton>
  );
};
